"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gatherReactSelectOptions = exports.checkArrayValueChanges = exports.checkBooleanValueChanges = exports.checkStringValueChanges = exports.getReactSelectOptionsValues = exports.isNonEmptyArray = exports.isReactSelectOptionEqual = exports.getReactSelectOption = exports.createReactSelectOptions = exports.isNonEmptyString = exports.isStringEqualCI = exports.isStringEqual = exports.formatAxiosError = exports.emptyReactSelectOption = exports.formatterCurrencyUSD = exports.arrayMove = exports.getEnumKeyByValue = exports.isExpired = exports.isActive = exports.formatDateToPST = exports.formatDateToUTC = exports.dateToMoment = exports.localDate = exports.utcDate = exports.isDateEqual = exports.isArrayEqual = exports.update = exports.except = exports.intersect = exports.roundCurrency = exports.formatCurrency = exports.normalizePriceString = exports.priceStringToCents = exports.formatBoolean = exports.getBoolean = exports.isBoolean = exports.isNumeric = exports.isNumber = exports.isDate = exports.isObject = exports.isFunction = exports.isString = void 0;
var tslib_1 = require("tslib");
var dinero_js_1 = (0, tslib_1.__importDefault)(require("dinero.js"));
var moment_1 = (0, tslib_1.__importDefault)(require("moment"));
require("moment-timezone");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isString = function (value) {
    return typeof value === 'string';
};
exports.isString = isString;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isFunction = function (value) {
    return (value &&
        (typeof value === 'function' ||
            value instanceof Function ||
            toString.call(value) === '[object Function]'));
};
exports.isFunction = isFunction;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isObject = function (value) {
    return value && toString.call(value) === '[object Object]';
};
exports.isObject = isObject;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isDate = function (value) {
    return (value &&
        (value instanceof Date || toString.call(value) === '[object Date]') &&
        value.toString() !== 'Invalid Date');
};
exports.isDate = isDate;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isNumber = function (value) {
    return typeof value === 'number' && isFinite(value);
};
exports.isNumber = isNumber;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isNumeric = function (value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
};
exports.isNumeric = isNumeric;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isBoolean = function (value) {
    return typeof value === 'boolean';
};
exports.isBoolean = isBoolean;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getBoolean = function (value) {
    return (0, exports.isBoolean)(value)
        ? value
        : (0, exports.isNumber)(value)
            ? value !== 0
            : (0, exports.isString)(value)
                ? /true/i.test(value)
                : false;
};
exports.getBoolean = getBoolean;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var formatBoolean = function (value, formatYesNo) {
    return (0, exports.getBoolean)(value)
        ? formatYesNo
            ? 'Yes'
            : 'True'
        : formatYesNo
            ? 'No'
            : 'False';
};
exports.formatBoolean = formatBoolean;
var priceStringToCents = function (price) {
    var normalizedPrice = (0, exports.normalizePriceString)(price);
    return (0, exports.isString)(normalizedPrice) && !!normalizedPrice
        ? parseInt(normalizedPrice.replace(/\D/g, ''), 10)
        : 0;
};
exports.priceStringToCents = priceStringToCents;
var normalizePriceString = function (price, decimalSeparator, scale) {
    if (decimalSeparator === void 0) { decimalSeparator = '.'; }
    if (scale === void 0) { scale = 2; }
    if (!(0, exports.isString)(price) || !price.length) {
        return price;
    }
    var length = price.length;
    var idx = price.lastIndexOf(decimalSeparator);
    var count = scale - (idx !== -1 ? length - idx - 1 : 0);
    return count >= 0
        ? "".concat(price).concat(idx === -1 ? decimalSeparator : '').concat('0'.repeat(count))
        : parseFloat(price).toFixed(scale);
};
exports.normalizePriceString = normalizePriceString;
var formatCurrency = function (value) {
    var valueDigits = value.replace(/\D/g, '');
    var formattedValue = (0, dinero_js_1.default)({
        amount: parseFloat(valueDigits || '0'),
    }).toFormat('0,0.00');
    return formattedValue;
};
exports.formatCurrency = formatCurrency;
var roundCurrency = function (value) {
    return !isNaN(value) ? Math.round((value + Number.EPSILON) * 100) / 100 : 0.0;
};
exports.roundCurrency = roundCurrency;
var intersect = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
left, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
right, compareFn) {
    return Array.isArray(left) && Array.isArray(right)
        ? left.filter(function (leftItem) {
            return ((0, exports.isFunction)(compareFn)
                ? right.findIndex(function (rightItem) { return compareFn(leftItem, rightItem); })
                : right.indexOf(leftItem)) !== -1;
        })
        : [];
};
exports.intersect = intersect;
var except = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
left, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
right, compareFn) {
    return Array.isArray(left) && Array.isArray(right)
        ? left.filter(function (leftItem) {
            return ((0, exports.isFunction)(compareFn)
                ? right.findIndex(function (rightItem) { return compareFn(leftItem, rightItem); })
                : right.indexOf(leftItem)) === -1;
        })
        : Array.isArray(left)
            ? left
            : [];
};
exports.except = except;
var update = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
left, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
right, compareFn) {
    return Array.isArray(left) && Array.isArray(right)
        ? (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], (0, exports.intersect)(left, right, compareFn), true), (0, exports.except)(right, left, compareFn), true) : Array.isArray(left) && !Array.isArray(right)
        ? left
        : !Array.isArray(left) && Array.isArray(right)
            ? right
            : [];
};
exports.update = update;
var isArrayEqual = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
left, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
right, compareFn) {
    return (left == null && right == null) ||
        (Array.isArray(left) &&
            Array.isArray(right) &&
            (left === right ||
                (left.length === right.length && !(0, exports.except)(left, right, compareFn).length)));
};
exports.isArrayEqual = isArrayEqual;
var isDateEqual = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
left, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
right, compareFn) {
    return (0, exports.isFunction)(compareFn)
        ? compareFn === null || compareFn === void 0 ? void 0 : compareFn(left, right)
        : left == right ||
            ((0, exports.isDate)(left) && (0, exports.isDate)(right) && (left === null || left === void 0 ? void 0 : left.valueOf()) == (right === null || right === void 0 ? void 0 : right.valueOf()));
};
exports.isDateEqual = isDateEqual;
var utcDate = function (date, roundToDate) {
    return moment_1.default
        .utc((0, tslib_1.__spreadArray)([
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
    ], (!roundToDate
        ? [
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
            date.getMilliseconds(),
        ]
        : []), true))
        .toDate();
};
exports.utcDate = utcDate;
var localDate = function (date) {
    var m = moment_1.default.utc(date);
    return new Date(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds(), m.millisecond());
};
exports.localDate = localDate;
var dateToMoment = function (date) {
    return (0, exports.isDate)(date)
        ? (0, moment_1.default)(date)
        : (0, exports.isString)(date) && !!date
            ? (0, moment_1.default)(new Date(date))
            : undefined;
};
exports.dateToMoment = dateToMoment;
var formatDateToUTC = function (date) {
    var m = (0, exports.dateToMoment)(date);
    return m && m.isValid() ? m.utc().format('MM/DD/YYYY hh:mm a z') : undefined;
};
exports.formatDateToUTC = formatDateToUTC;
var formatDateToPST = function (date) {
    var m = (0, exports.dateToMoment)(date);
    return m.isValid()
        ? m.tz('America/Los_Angeles').format('MM/DD/YYYY hh:mm a z')
        : undefined;
};
exports.formatDateToPST = formatDateToPST;
var isActive = function (fromDate, toDate) {
    var fromM = (0, exports.dateToMoment)(fromDate), toM = (0, exports.dateToMoment)(toDate), current = (0, moment_1.default)();
    if (fromM && fromM.isValid()) {
        fromM.hour(0).minute(0).second(0).millisecond(0);
    }
    if (toM && toM.isValid()) {
        toM.hour(23).minute(59).second(59).millisecond(999);
    }
    if (fromM && fromM.isValid() && toM && toM.isValid()) {
        return current.isBetween(fromM, toM);
    }
    else if (fromM && fromM.isValid()) {
        return current.isSameOrAfter(fromM);
    }
    else if (toM && toM.isValid()) {
        return current.isSameOrBefore(toM);
    }
    return true;
};
exports.isActive = isActive;
var isExpired = function (toDate) {
    var toM = (0, exports.dateToMoment)(toDate), current = (0, moment_1.default)();
    if (toM && toM.isValid()) {
        toM.hour(23).minute(59).second(59).millisecond(999);
    }
    return toM && toM.isValid() && current.isAfter(toM);
};
exports.isExpired = isExpired;
function getEnumKeyByValue(myEnum, enumValue) {
    var keys = Object.keys(myEnum).filter(function (x) { return myEnum[x] == enumValue; });
    return keys.length > 0 ? keys[0] : null;
}
exports.getEnumKeyByValue = getEnumKeyByValue;
function arrayMove(array, from, to) {
    var slicedArray = array.slice();
    slicedArray.splice(to < 0 ? array.length + to : to, 0, slicedArray.splice(from, 1)[0]);
    return slicedArray;
}
exports.arrayMove = arrayMove;
exports.formatterCurrencyUSD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
exports.emptyReactSelectOption = {
    value: '',
    label: '',
};
var formatAxiosError = function (error) {
    var _a, _b;
    return (error === null || error === void 0 ? void 0 : error.response)
        ? "".concat(((_a = error.response.data) === null || _a === void 0 ? void 0 : _a.error) ||
            ((_b = error.response.data) === null || _b === void 0 ? void 0 : _b.message) ||
            error.response.statusText, " (").concat(error.response.status, ")")
        : (error === null || error === void 0 ? void 0 : error.message)
            ? error.message
            : 'Unknown error';
};
exports.formatAxiosError = formatAxiosError;
var isStringEqual = function (left, right, caseInsensitive) {
    return (left == null && right == null) ||
        ((0, exports.isString)(left) &&
            (0, exports.isString)(right) &&
            (caseInsensitive ? left.trim().toLowerCase() : left.trim()) ===
                (caseInsensitive ? right.trim().toLowerCase() : right.trim()));
};
exports.isStringEqual = isStringEqual;
var isStringEqualCI = function (left, right) {
    return (0, exports.isStringEqual)(left, right, true);
};
exports.isStringEqualCI = isStringEqualCI;
var isNonEmptyString = function (str) {
    return (0, exports.isString)(str) && str.trim().length > 0;
};
exports.isNonEmptyString = isNonEmptyString;
var createReactSelectOptions = function (values, addEmptyOptions) {
    return Array.isArray(values)
        ? (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], (addEmptyOptions ? [exports.emptyReactSelectOption] : []), true), values
            .filter(function (item) { return (0, exports.isNonEmptyString)(item); })
            .map(function (item) { return ({
            value: item.trim().toLowerCase(),
            label: item.trim(),
        }); }), true) : undefined;
};
exports.createReactSelectOptions = createReactSelectOptions;
var getReactSelectOption = function (options, value) {
    return (0, exports.isNonEmptyArray)(options)
        ? options.find(function (item) {
            return (0, exports.isFunction)(value)
                ? value(item.value)
                : (0, exports.isNonEmptyString)(value)
                    ? (0, exports.isStringEqualCI)(item.value, value)
                    : undefined;
        })
        : undefined;
};
exports.getReactSelectOption = getReactSelectOption;
var isReactSelectOptionEqual = function (left, right) { return (0, exports.isStringEqualCI)(left.value, right.value); };
exports.isReactSelectOptionEqual = isReactSelectOptionEqual;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isNonEmptyArray = function (arr) {
    return Array.isArray(arr) && arr.length > 0;
};
exports.isNonEmptyArray = isNonEmptyArray;
var getReactSelectOptionsValues = function (options) {
    return (0, exports.isNonEmptyArray)(options) ? options.map(function (item) { return item.value; }) : [];
};
exports.getReactSelectOptionsValues = getReactSelectOptionsValues;
var checkStringValueChanges = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
previous, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
current, fieldName, changes, caseSensitive) {
    if (!(0, exports.isNonEmptyString)(fieldName) || !Array.isArray(changes)) {
        return changes;
    }
    fieldName = fieldName.trim();
    var previousValue = previous === null || previous === void 0 ? void 0 : previous[fieldName];
    var currentValue = current === null || current === void 0 ? void 0 : current[fieldName];
    if (previousValue == null && currentValue == null) {
        return changes;
    }
    var isEqualFn = caseSensitive ? exports.isStringEqual : exports.isStringEqualCI;
    if (!isEqualFn(previousValue, currentValue)) {
        changes.push({
            key: fieldName,
            previusValue: (0, exports.isString)(previousValue)
                ? "\"".concat(previousValue.trim(), "\"")
                : typeof previousValue,
            currentValue: (0, exports.isString)(currentValue)
                ? "\"".concat(currentValue.trim(), "\"")
                : typeof currentValue,
        });
    }
    return changes;
};
exports.checkStringValueChanges = checkStringValueChanges;
var checkBooleanValueChanges = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
previous, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
current, fieldName, changes) {
    if (!(0, exports.isNonEmptyString)(fieldName) || !Array.isArray(changes)) {
        return changes;
    }
    fieldName = fieldName.trim();
    var previousValue = previous === null || previous === void 0 ? void 0 : previous[fieldName];
    var currentValue = current === null || current === void 0 ? void 0 : current[fieldName];
    if (previousValue == null && currentValue == null) {
        return changes;
    }
    if (previousValue !== currentValue) {
        changes.push({
            key: fieldName,
            previusValue: (0, exports.isBoolean)(previousValue)
                ? previousValue
                : typeof previousValue,
            currentValue: (0, exports.isBoolean)(currentValue)
                ? currentValue
                : typeof currentValue,
        });
    }
    return changes;
};
exports.checkBooleanValueChanges = checkBooleanValueChanges;
var checkArrayValueChanges = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
previousValue, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
currentValue, fieldName, changes, compareFn, toStringFn) {
    if (!(0, exports.isNonEmptyString)(fieldName) || !Array.isArray(changes)) {
        return changes;
    }
    if (!(0, exports.isArrayEqual)(previousValue, currentValue, compareFn)) {
        changes.push({
            key: fieldName,
            previusValue: Array.isArray(previousValue)
                ? "[".concat(previousValue
                    .map(function (item) {
                    return "\"".concat((0, exports.isFunction)(toStringFn) ? toStringFn(item) : item.toString(), "\"");
                })
                    .join(), "]")
                : typeof previousValue,
            currentValue: Array.isArray(currentValue)
                ? "[".concat(currentValue
                    .map(function (item) {
                    return "\"".concat((0, exports.isFunction)(toStringFn) ? toStringFn(item) : item.toString(), "\"");
                })
                    .join(), "]")
                : typeof currentValue,
        });
    }
    return changes;
};
exports.checkArrayValueChanges = checkArrayValueChanges;
var gatherReactSelectOptions = function (options, additionalOptions) {
    if (!(0, exports.isNonEmptyArray)(additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.options)) {
        return options;
    }
    var result = (0, tslib_1.__spreadArray)([], additionalOptions.options, true);
    if (!(0, exports.isNonEmptyArray)(options)) {
        return result;
    }
    for (var i = 0, l = options.length; i < l; ++i) {
        var option = options[i];
        if (!(0, exports.isNonEmptyString)(option.value)) {
            continue;
        }
        if (!(0, exports.getReactSelectOption)(result, option.value)) {
            result[(additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.position) === 'top' ? 'push' : 'unshift'](option);
        }
    }
    return result;
};
exports.gatherReactSelectOptions = gatherReactSelectOptions;
